import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n';
import { validateEnvironment, displayEnvErrors, renderEnvErrorUI } from './lib/validateEnv';

// Validate environment variables before starting the app
const { valid, errors } = validateEnvironment();

if (!valid) {
  // Display errors in console
  displayEnvErrors(errors);
  
  // Render friendly error UI
  document.getElementById('root')!.innerHTML = renderEnvErrorUI(errors);
} else {
  // All good - start the app
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
